"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
const MD_BREAKPOINT = 768;
export function useResponsivePageSize(desktopSize, mobileSize) {
  const $ = _c(4);
  const [pageSize, setPageSize] = useState(desktopSize);
  let t0;
  let t1;
  if ($[0] !== desktopSize || $[1] !== mobileSize) {
    t0 = () => {
      const mediaQuery = window.matchMedia(`(max-width: ${MD_BREAKPOINT - 1}px)`);
      const updatePageSize = () => {
        setPageSize(mediaQuery.matches ? mobileSize : desktopSize);
      };
      updatePageSize();
      mediaQuery.addEventListener("change", updatePageSize);
      return () => {
        mediaQuery.removeEventListener("change", updatePageSize);
      };
    };
    t1 = [desktopSize, mobileSize];
    $[0] = desktopSize;
    $[1] = mobileSize;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return pageSize;
}